(() => {
  if (window.kelyThemeReady) return;
  window.kelyThemeReady = true;
  const closeMenus = (except) => document.querySelectorAll('[data-kely-header]').forEach(header => {
    if (header === except) return;
    header.querySelector('[data-kely-mobile-menu]')?.classList.remove('is-open');
    header.querySelector('[data-kely-menu-button]')?.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-kely-menu-button]');
    if (toggle) {
      const header = toggle.closest('[data-kely-header]');
      closeMenus(header);
      const open = header.querySelector('[data-kely-mobile-menu]').classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!event.target.closest('[data-kely-header]') || event.target.closest('[data-kely-mobile-menu] a')) closeMenus();
    const trigger = event.target.closest('[data-kely-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.kelyOpen);
      if (dialog?.showModal) {event.preventDefault(); dialog.showModal(); dialog.querySelector('input[type=email]')?.focus();}
    }
    const closer = event.target.closest('[data-kely-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.kely-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const button = document.querySelector('[data-kely-menu-button][aria-expanded="true"]');
    if (button) {closeMenus();button.focus();}
  });
  function restoreFormFeedback(root = document) {
    root.querySelectorAll('dialog.kely-dialog').forEach(dialog => {
      if (dialog.querySelector('[data-kely-form-result]') && !dialog.open && dialog.showModal) dialog.showModal();
    });
  }
  restoreFormFeedback();
  document.addEventListener('shopify:section:load', event => restoreFormFeedback(event.target));
})();
